export const aloneApi = {
  getSessionId: { // 获取session-id
      method: 'get',
      api: 'backend/common/getSessionId'
  },
  changepwd: { // 登录
    method: 'post',
    api: 'backend/user/changepwd'
},
  login: { // 登录
      method: 'post',
      api: 'backend/login/login'
  },
  getLoginStatus: { // 获取当前登录状态
    method: 'get',
    api: 'backend/common/loginStatus'
  },
  loginout: { // 获取当前登录状态
    method: 'get',
    api: 'backend/login/loginout'
  },
}